var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chip1)?_c('v-chip',{staticClass:"ma-2",attrs:{"close":"","color":"success","outlined":""},on:{"click:close":function($event){_vm.chip1 = false}}},[_vm._v(" "+_vm._s(_vm.item.grupo_departamento.descricao)+" - "+_vm._s(_vm.item.vlr_valor)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }